import React, { SyntheticEvent, useEffect, useState } from "react";
import images from "../../assets/images";
import "./Legal.scss";
import { StyledTabs, CustomTab } from "../Help/TermsAndPrivacyPolicy";
import axios, { AxiosResponse } from "axios";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";

const Legal: React.FC = () => {
  const { Legal , LegalBackIcon} = images;
  const [activeTab, setActiveTab] = useState(0);
  const [content, setContent] = useState();
  const [data, setData] = useState("");
  const navigate = useNavigate();
  const katon_cms = process.env.REACT_APP_KATON_CMS_SITE;
  const [loading, setLoading] = useState<boolean>(false);

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: AxiosResponse = await axios.get(
          `${katon_cms}/classroom_legals`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const content = response.data;
        setContent(content);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (content) {
      switch (activeTab) {
        case 0:
          setData(content[0]["Privacy Policy"]);
          break;
        case 1:
          setData(content[0]["Terms of Use"]);
          break;
        case 2:
          setData(content[0]["Cancellation Policy"]);
          break;
      }
    }
  }, [activeTab, content]);

  const handleBackIcon = () => {
    navigate('/');
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="legal-container">
          <div className="title">
            <div className="legalHeadingContainer">
              <img alt="backIcon" src={LegalBackIcon} className="legalBackIconStyle" onClick={handleBackIcon}/>
              <div className="heading">Legal</div>
            </div>
            <div className="picture">
              <img src={Legal} alt="legal" />
            </div>
          </div>
          <StyledTabs value={activeTab} onChange={handleChangeTab}>
            <CustomTab label={"Privacy Policy"} className="privacyPolicyTab"/>
            <CustomTab label={"Terms of Use"} className="termsOfUseTab"/>
            <CustomTab label={"Cancellation Policy"} className="cancellationPolicyTab"/>
          </StyledTabs>
          <div
            className="privacy-policy-content"
            dangerouslySetInnerHTML={{ __html: data }}
          ></div>
        </div>
      )}
    </>
  );
};

export default Legal;
